module.exports = __webpack_public_path__ + "static/media/ams-success-img-sky-blue.3a10a409.png";